module.exports = __webpack_public_path__ + "static/media/ball-detection.9df21833.svg";